import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

export interface ContactData {
  link: string;
  label: string;
  icon: IconDefinition;
}

const data: ContactData[] = [
  {
    link: 'https://github.com/grapentt',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://www.linkedin.com/in/thomas-grapentin-a22024210',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'mailto:thomas.grapentin@gmx.de',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
